import { nestRichTextLists, normalizeRichTextContent } from "./richText";
import type { RichTextContent } from "./types";

type RichTextRendererProps = {
  content: RichTextContent | string | null | undefined;
  variant?: "article" | "note";
};

/**
 * Renders stored rich-text HTML produced by the Quill editor. Content is
 * re-sanitized before injection and wrapped in Quill's read-only classes so the
 * display matches the editor (lists, checklists, alignment, code, tables).
 */
export function RichTextContentRenderer({ content, variant = "article" }: RichTextRendererProps) {
  const normalized = normalizeRichTextContent(content);
  const html = normalized?.html ? nestRichTextLists(normalized.html) : "";

  if (!html) {
    return null;
  }

  return (
    <div className={`ql-snow rich-text-content rich-text-content--${variant}`}>
      <div className="ql-editor" dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
